// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qN-z","hovered":"rN-z","hoverImage":"sN-z","mainImage":"tN-z","imageNoBackground":"uN-z","fullSizeImage":"vN-z"};